import { ProductsTFunction } from '@retail/products/i18n';
import { subDays } from 'date-fns';
import * as yup from 'yup';

export const expireItemsSchema = (t: ProductsTFunction) =>
  yup.object({
    fromDate: yup
      .date()
      .nullable()
      .default(null)
      .min(subDays(new Date(), 1), t('products.mgItem.fromDate.validation.min')),
  });

export type ExpireItemsSchema = yup.InferType<ReturnType<typeof expireItemsSchema>>;
